// Global error handler for API errors
// Handles authentication errors, authorization errors, and other API errors
import { ApiError } from "./httpClient";
let errorHandlerConfig = {};
/**
 * Configure the global error handler
 * This should be called once at app initialization
 */
export function configureErrorHandler(config) {
    errorHandlerConfig = config;
}
/**
 * Handle API errors globally
 * This function checks for specific error types and triggers appropriate handlers
 */
export function handleApiError(error) {
    // Handle ApiError instances
    if (error instanceof ApiError) {
        // 401 - Authentication error (session expired)
        if (error.status === 401) {
            // Clear auth token from localStorage
            localStorage.removeItem("auth_token");
            // Trigger auth error handler (redirect to login)
            if (errorHandlerConfig.onAuthError) {
                errorHandlerConfig.onAuthError();
            }
            return new Error("Your session has expired. Please log in again.");
        }
        // 403 - Authorization error (insufficient permissions)
        if (error.status === 403) {
            // Trigger authorization error handler
            if (errorHandlerConfig.onAuthorizationError) {
                errorHandlerConfig.onAuthorizationError();
            }
            return new Error("You don't have permission to perform this action.");
        }
        // Return the original error for other status codes
        return error;
    }
    // Handle network errors
    if (error instanceof TypeError && error.message.includes("fetch")) {
        if (errorHandlerConfig.onNetworkError) {
            errorHandlerConfig.onNetworkError();
        }
        return new Error("Network error. Please check your connection.");
    }
    // Handle generic errors
    if (error instanceof Error) {
        return error;
    }
    // Unknown error type
    return new Error("An unexpected error occurred");
}
/**
 * Check if an error is an authentication error (401)
 */
export function isAuthError(error) {
    return error instanceof ApiError && error.status === 401;
}
/**
 * Check if an error is an authorization error (403)
 */
export function isAuthorizationError(error) {
    return error instanceof ApiError && error.status === 403;
}
/**
 * Check if an error is a network error
 */
export function isNetworkError(error) {
    return error instanceof TypeError && error.message.includes("fetch");
}
/**
 * Extract user-friendly error message from an error
 */
export function getErrorMessage(error) {
    if (error instanceof ApiError) {
        if (error.status === 401) {
            return "Your session has expired. Please log in again.";
        }
        if (error.status === 403) {
            return "You don't have permission to perform this action.";
        }
        return error.message;
    }
    if (error instanceof TypeError && error.message.includes("fetch")) {
        return "Network error. Please check your connection.";
    }
    if (error instanceof Error) {
        return error.message;
    }
    return "An unexpected error occurred";
}
